export const ZonesData = [
    {
        index: 3,
        zoneX: 960,
        zoneY: 388,
        zoneId: 2,
        image: "zoneFinancement",
        dZoneX: 437,
        dZoneY: -713,
        finalX: 1520,
        finalY: 140,
    },
    {
        index: 2,
        zoneX: 595,
        zoneY: 388,
        zoneId: 1,
        image: "zoneInvestissement",
        dZoneX: -100,
        dZoneY: -706,
        finalX: 982,
        finalY: 147,
    },
    {
        index: 1,
        zoneX: 422,
        zoneY: 388,
        zoneId: 0,
        image: "zoneExploitation",
        dZoneX: -662,
        dZoneY: -700,
        finalX: 421,
        finalY: 153,
    },
]